import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// LOGIN
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';

export const router: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: 'admin', loadChildren: 'app/admin/admin.module#AdminModule' }
];

export const routes: ModuleWithProviders = RouterModule.forRoot(router);



// WEBPACK FOOTER //
// ./src/app/app.router.ts